export default __webpack_public_path__ + "static/ed-logo-2d44864fe41d4f66be34dee81137fce9.png";